<div class="startup_center center" style="width: 95%; border-style: dashed; border-width: 1px; border-color: lightgray;" *ngIf="localService.languageContent && localService.languageContent.startup">
  <div class="table">
    <div class="row">
      <div class="col-8">
        <div class="wrap startup_center">
          {{localService.languageContent.startup.my_biz}}
        </div>
        <div class="wrap startup_center">
          {{localService.languageContent.startup.address_1}}
        </div>
        <div class="wrap startup_center">
          {{localService.languageContent.startup.address_2}}
        </div>
        <div class="wrap startup_center">
          <span>{{localService.languageContent.startup.contact}}</span><span class="en">&nbsp;:&nbsp;+91 75500 37222</span>
        </div>
        <div class="wrap startup_center">
          <span>{{localService.languageContent.startup.token}}</span><span class="en">&nbsp;:&nbsp;20220923-143</span>
        </div>
      </div>
      <div class="col-4">
        <qrcode [qrdata]="'https://bill.sndigisol.com'" [width]="100" [errorCorrectionLevel]="'H'" [colorDark]="'#989898'"></qrcode>
      </div>
    </div>
    <div class="row">
      <div class="col-4 wrap border-bottom border-top">
        {{localService.languageContent.startup.item}}
      </div>
      <div class="col-3 wrap right border-bottom border-top">
        {{localService.languageContent.startup.price}}
      </div>
      <div class="col-2 wrap right border-bottom border-top">
        {{localService.languageContent.startup.qty}}
      </div>
      <div class="col-3 wrap right border-bottom border-top">
        {{localService.languageContent.startup.total}}
      </div>
    </div>
    <div class="row" *ngFor="let item of items">
      <div class="col-4 wrap left">
        <span class="en">{{item.v1}} - </span><span>{{getName(item.v2)}}</span>
      </div>
      <div class="col-3 right en wrap">
        <span>{{item.v3 | number: '1.2-2'}}</span>
      </div>
      <div class="col-2 right en wrap">
        <span>{{item.v4}}</span>
      </div>
      <div class="col-3 right en wrap">
        <span>{{getTotal(item.v3, item.v4) | number: '1.2-2'}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-9 border-top">
        <span>{{localService.languageContent.startup.gtotal}}</span><span class="en">&nbsp;({{items.length}})</span>
      </div>
      <div class="col-3 right border-top">
        <span class="en">{{getGrandTotal() | number: '1.2-2'}}</span>
      </div>
    </div>
  </div>  
</div>
